var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorloge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5594_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C4.41221 0 3.34884 0.322569 2.44437 0.926917C1.5399 1.53126 0.834947 2.39025 0.418665 3.39524C0.00238307 4.40023 -0.106535 5.5061 0.105683 6.573C0.317902 7.63989 0.841726 8.6199 1.61092 9.38909C2.3801 10.1583 3.36011 10.6821 4.42701 10.8943C5.4939 11.1065 6.59977 10.9976 7.60476 10.5813C8.60975 10.1651 9.46874 9.46011 10.0731 8.55564C10.6774 7.65117 11 6.5878 11 5.5C10.9984 4.04179 10.4185 2.64376 9.38735 1.61265C8.35624 0.581546 6.95821 0.00157716 5.5 0ZM5.95834 5.44454C5.95838 5.52223 5.93868 5.59867 5.90108 5.66665C5.86348 5.73464 5.80921 5.79195 5.74338 5.83321L3.98338 6.93321C3.93222 6.96517 3.87526 6.98674 3.81576 6.99669C3.75627 7.00664 3.69539 7.00477 3.63662 6.99119C3.57784 6.97762 3.52232 6.9526 3.47321 6.91756C3.4241 6.88253 3.38238 6.83816 3.35042 6.787C3.31846 6.73584 3.29689 6.67888 3.28694 6.61939C3.27699 6.55989 3.27886 6.49902 3.29243 6.44024C3.30601 6.38146 3.33103 6.32594 3.36607 6.27683C3.4011 6.22773 3.44547 6.186 3.49663 6.15404L5.04167 5.19063V3.20833C5.04167 3.08678 5.08996 2.9702 5.17591 2.88424C5.26187 2.79829 5.37844 2.75 5.5 2.75C5.62156 2.75 5.73814 2.79829 5.82409 2.88424C5.91005 2.9702 5.95834 3.08678 5.95834 3.20833V5.44454Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5594_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorloge);
export default __webpack_public_path__ + "static/media/horloge.1c901f24f599e35e93553d99dc74ebf3.svg";
export { ForwardRef as ReactComponent };